import React from 'react'

export function Icon({ children, icon, size, button, style, className, color = 'inherit' }) {
  return (
    <span className={className} style={{ ...style, color: color, transform: button ? 'translateX(-0.2em)' : 'none' }}>
      <span className={`t_icon ${button ? `t_icon--button` : ``} ${size ? `t_icon--${size}` : ''}`}>{children || icon}</span>
    </span>
  )
}

